import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const itemCreateAtom = createMutationAtomFactory(
  'settings.itemCreate',
  (params: {
    categoryId: string;
    itemGroupId: string;
    skuNumber: string;
    name: string;
    description: string;
    notes: string;
    measurementUnit: string;
    pricingUnitOverride?: string | null;
    attributeValues: Record<string, unknown>;
    customAttributes?: Record<string, unknown> | null;
  }) => ({
    inventoryItemCreate: {
      __args: {
        input: {
          categoryId: params.categoryId,
          itemGroupId: params.itemGroupId,
          skuNumber: params.skuNumber,
          name: params.name,
          description: params.description,
          notes: params.notes,
          measurementUnit: params.measurementUnit,
          pricingUnitOverride: params.pricingUnitOverride,
          attributeValues: JSON.stringify(params.attributeValues),
          customAttributes: params.customAttributes,
        },
      },
      id: true,
      name: true,
      skuNumber: true,
      timestamps: {
        createdAt: true,
      },
    },
  }),
);
